import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take, takeUntil, tap } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';
import * as authActions from '@auth/store/auth.actions';
import { DataService } from '@data/data.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  showMenu: BehaviorSubject<string> = new BehaviorSubject('none');
  showMenu$: Observable<string>;

  permissions: { facility: string; allow: any; deny: any };
  isSuper = false;

  private currentShowing: string;
  public menuMarginLeft = {};

  hasAdminPermission: boolean = false;
  hasInvInquirePermission: boolean = false;
  hasOrdCreatePermission: boolean = false;
  hasOrdInquirePermission: boolean = false;
  hasReportsPermission: boolean = false;

  constructor(public router: Router, public authS: AuthService, private store: Store, public dataService: DataService) {
    this.showMenu$ = this.showMenu.pipe(
      tap((show) => {
        this.currentShowing = show;
      }),
      takeUntil(this.destroy$)
    );

    this.authS.authData$.pipe(take(1)).subscribe((obj) => {
      this.isSuper = obj.groupid === 'SUPER' ? true : false;
    });
  }

  ngOnInit() {
    window.addEventListener('orientationchange', () => this.dismissMenu());

    this.hasAdminPermission = this.authS.hasPermission('WSADMIN');
    this.hasInvInquirePermission = this.authS.hasPermission('WSINVINQUIRE');
    this.hasOrdCreatePermission = this.authS.hasPermission('WSORDCREATE');
    this.hasOrdInquirePermission = this.authS.hasPermission('WSORDINQUIRE');
    this.hasReportsPermission = this.authS.hasPermission('WSREPORTS');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  logout() {
    this.store.dispatch(new authActions.Logout());
  }

  gotoRoute(route: string) {
    this.dismissMenu();
    this.router.navigateByUrl(route);
  }

  toggleMenu(type: string) {
    this.showMenu.next(this.currentShowing === type ? 'none' : type);

    const element = document.getElementById(type);
    const rect = element.getBoundingClientRect();
    this.menuMarginLeft = { marginLeft: `${Math.round(rect.left) - 25}px` };
  }

  dismissMenu() {
    this.dataService.hideFullScreen.next(false);
    this.showMenu.next('none');
  }

  showChangeCustomer() {
    setTimeout(() => this.authS.changeCustomerDialog$.next(true), 50);
  }

  showChangeFacility() {
    setTimeout(() => this.authS.changeFacilityDialog$.next(true), 50);
  }
}
